import { ServerModel } from '@wix/package-picker-shared';
export const eclipseServerData = new ServerModel();
//# sourceMappingURL=eclipseServerData.js.map